import styled from 'styled-components';
import { PlayLinkContainer } from '../../components/Link';
import { device } from '../breakpoints';
import { regularOutline } from '../typography/helpers';

export const ContentItemWrapper = styled.article`
    width: 100%;
    display: inline-block;
    vertical-align: top;
    white-space: normal;
    margin-bottom: 20px;

    @media ${device.GteMedium} {
        margin-bottom: 30px;
    }
`;

export const ContentItemLink = styled(PlayLinkContainer)`
    display: block;
    text-decoration: none;

    &:focus {
        ${regularOutline(2)}
    }
`;

export const ThumbnailWrapper = styled.div`
    position: relative;
`;
